module.exports = __webpack_public_path__ + "static/media/bg-chat.f1107c0a.jpeg";